import { Input } from '@/shared/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/select'
import { Avatar, AvatarFallback } from '@/shared/components/ui/avatar'
import type { Settings } from '@/shared/cache/slices/settings.types'
import { useAuthCache } from '@/shared/cache'
import { SettingGroup, SettingRow } from '../SettingsShared'

export interface BillingSettingsProps {
  settings: Settings
  update: (patch: Partial<Settings>) => void
}

export function BillingSettings({ settings, update }: BillingSettingsProps) {
  const { auth } = useAuthCache()

  return (
    <>
      <SettingGroup label="Profile">
        <div className="flex gap-4 py-5 border-b border-border/40">
          <div className="w-1/3 flex flex-col gap-1.5">
            <label className="text-sm font-medium text-foreground">Name</label>
            <div className="flex items-center gap-2">
              <Avatar className="h-8 w-8 shrink-0">
                <AvatarFallback className="bg-sidebar-primary text-sidebar-primary-foreground text-xs font-medium">
                  {auth.initials}
                </AvatarFallback>
              </Avatar>
              <Input
                value={auth.displayName}
                disabled
                className="w-full opacity-70 cursor-not-allowed"
              />
            </div>
          </div>
          <div className="w-2/3 flex flex-col gap-1.5">
            <label className="text-sm font-medium text-foreground">Email</label>
            <Input
              value={auth.email}
              disabled
              className="w-full opacity-70 cursor-not-allowed"
            />
          </div>
        </div>
        <SettingRow
          label="Practice area"
          description="Your area of legal practice, used to tailor generated narratives"
        >
          <Input
            value={settings.practice_type}
            onChange={(e) => update({ practice_type: e.target.value })}
            className="w-52"
          />
        </SettingRow>
        <SettingRow
          label="Role"
          description="Your professional role (e.g. Associate, Partner)"
        >
          <Input
            value={settings.prof_type}
            onChange={(e) => update({ prof_type: e.target.value })}
            className="w-52"
          />
        </SettingRow>
      </SettingGroup>

      <SettingGroup label="Billing">
        <SettingRow
          label="Minimum billable increments"
          description="Smallest time increment used when rounding billable hours"
        >
          <Select
            value={settings.minimum_units ? '0.2' : '0.1'}
            onValueChange={(v) => update({ minimum_units: v === '0.2' })}
          >
            <SelectTrigger className="w-36">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="0.1">0.1 hours</SelectItem>
              <SelectItem value="0.2">0.2 hours</SelectItem>
            </SelectContent>
          </Select>
        </SettingRow>
      </SettingGroup>

    </>
  )
}
